import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { NoData } from "../../../components/NoData";
import { useSelector } from "../../../store/hooks";
import { formatDateString } from "../../../utils/utils";
import { Label, Row } from "./RecommendationPanel";

export const Implemented = () => {
  const { t } = useTranslation();
  const loadRecommendationStatus = useSelector(
    (s) => s.recommendationPanel.loadRecommendationStatus
  );
  const recommendation = useSelector(
    (s) => s.recommendationPanel.recommendation
  );
  const isLoading = loadRecommendationStatus === "loading";

  let render;
  if (isLoading) render = <Skeleton width={100} />;
  else if (!recommendation) render = <NoData />;
  else if (!recommendation.implemented) render = <NoData />;
  else render = formatDateString(recommendation.implemented);

  return (
    <Row>
      <Label>{t("ram.recommendationForm.implemented.label")}:</Label>
      {render}
    </Row>
  );
};
